import React from 'react';
import "./Hero.scss";
import { useLanguage } from "../../LanguageContext";
import MeshGradient from "./Hero2";

const Hero = () => {
  const { t } = useLanguage();
  return (
    <div className="hero">
      <div className="gradient-container">
        <MeshGradient />
      </div>
      <div className="hero-content">
        <h1>{t("hero_title")}</h1>
        <p className="primary">{t("hero_description")}</p>
        <button>{t("hero_button")}</button>
      </div>
    </div>
  )
}

export default Hero

